import { render } from "./Breadcrumbs.vue?vue&type=template&id=1c9bc8e4"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/niam/Sites/mab/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/general/Breadcrumbs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c9bc8e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c9bc8e4', __exports__)) {
    console.log('reload')
    api.reload('1c9bc8e4', __exports__)
  }
  
  module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=1c9bc8e4", () => {
    console.log('re-render')
    api.rerender('1c9bc8e4', render)
  })

}


export default __exports__